import netflixLogo from './images/icons/netflix-logo.png';
import globoplayLogo from './images/icons/globoplay-logo.png';
import primeVideoLogo from './images/icons/prime-video-logo.png';
import disneyLogo from './images/icons/disney-logo.png';
import appleTvLogo from './images/icons/apple-tv-logo.png';
import maxLogo from './images/icons/max-logo.png';
import crunchyrollLogo from './images/icons/crunchyroll-logo.png';
import telecineLogo from './images/icons/telecine-logo.png';
import paramountLogo from './images/icons/paramount-logo.png';

const providersMovies = {
    "1": { "name": "Netflix", "background_color": "#ffffff", "text_color": "#e60914", "image_path": netflixLogo },
    "2": { "name": "Globoplay", "background_color": "#ffffff", "text_color": "#fa0a3a", "image_path": globoplayLogo },
    "3": { "name": "Prime Video", "background_color": "#ffffff", "text_color": "#0278bd", "image_path": primeVideoLogo },
    "4": { "name": "Disney+", "background_color": "#ffffff", "text_color": "#015b6b", "image_path": disneyLogo },
    "5": { "name": "Apple TV", "background_color": "#ffffff", "text_color": "#000000", "image_path": appleTvLogo },
    "6": { "name": "MAX", "background_color": "#ffffff", "text_color": "#0730e8", "image_path": maxLogo },
    "9": { "name": "Crunchyroll", "background_color": "#ffffff", "text_color": "#ff640a", "image_path": crunchyrollLogo },
    "10": { "name": "Telecine", "background_color": "#ffffff", "text_color": "#000069", "image_path": telecineLogo },
    "11": { "name": "Paramount", "background_color": "#ffffff", "text_color": "#000069", "image_path": paramountLogo },
    "1001": { "name": "Outro" }
};

export default providersMovies;
